import React, {useEffect} from "react";
import { ProductPage } from './productPage';
import styled from 'styled-components'

const ModalContainer = styled.div`
  position: relative;
  .modal-wrapper {
    width: auto;
    min-height: 100%;
    background-color: #41404A;
    position: absolute;
    z-index: 100;
    top: -200px;
    padding-bottom: 100%;
    left: -20px;
    right: -20px;
  }

  &&.without-tabs .modal-wrapper {
    top: -110px;
    left: 0;
    right: 0;
  }
`;


const ProductModalWrapper = ({ productId, withOutTabs, onClose }) => {

  /**
   * Will close product modal wrapper and updates the URL without triggering a
   * re-render or state update
   */
  const closeModal = () => {
    if (onClose) {
      onClose();
      window.history.pushState({}, '', `/#/chemicalList`);
    }
  };

  /**
   * This effect is used to updates the URL without triggering a re-render or state update
   */
  useEffect(() => {
    if (productId) {
      const contentContainerElem = document.getElementById('content-container');
      window.history.pushState({}, '', `/#/product/${productId}`);
      if (contentContainerElem) {
        document.getElementById('content-container').scrollTop = 0;
      }
    }
  }, [productId])

  return (
    <ModalContainer className={withOutTabs ? "without-tabs" : "with-tabs"}>
      <div className={onClose ? 'modal-wrapper modal-overlay' : 'modal-wrapper'} onClick={onClose}>
        <div className={onClose ? 'modal-content' : ''} onClick={(e) => e.stopPropagation()}>
          <ProductPage productId={productId} closeModal={closeModal}/>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ProductModalWrapper;
